import React from 'react';
import qrCards from '../assets/qr/*.jpg';
import qrCardNames from './qrCardNames';

const MemberQRCard = ({ slug }) => {
  const src = qrCards[slug];
  if (!src) return null;

  return (
    <div className="qr-card" style={{ marginTop: 20 }}>
      <h3 style={{ marginBottom: 10 }}>MEMBER QR CARD</h3>
      <img
        className="qr-card-img"
        src={src}
        alt={`QR card of ${qrCardNames[slug] || slug}`}
        style={{ width: 240, height: 'auto', borderRadius: 8 }}
      />
      <div style={{ marginTop: 12 }}>
        <a
          href={src}
          download={`${qrCardNames[slug] || slug} QR.jpg`}
          style={{
            display: 'inline-block',
            padding: '8px 20px',
            background: '#c62828',
            color: '#fff',
            borderRadius: 20,
            textDecoration: 'none',
            fontWeight: 'bold',
          }}
        >
          Download QR card
        </a>
      </div>
    </div>
  );
};

export default MemberQRCard;
